module.exports = __webpack_public_path__ + "img/PCM_Booth_Diamond_people_version_A1_4x3.28a7a7f9.png";